
import { useState, useEffect } from "react";

const useSlidesToShow = ()=> {
    const getSlides = () => (window.innerWidth < 768 ? 1 : 3);
    const [slides, setSlides] = useState(getSlides());

    useEffect(() => {
        const handleResize = () => setSlides(getSlides());
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return slides;
}

export default useSlidesToShow;